export default __webpack_public_path__ + "static/new-dropdown-c4ed59e84835c26cd0261ff3a0c8e9f4.png";